const ADDITIONAL_OFFER = 'additional-offer';

export { ADDITIONAL_OFFER };
